import {
  Box,
  Grid,
  Button,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import Buttons from "../../../components/Controls/buttons/Button";
import Header from "../../../components/header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import Radio from "@mui/material/Radio";
import FolderIcon from "@mui/icons-material/Folder";
import ProgressBar from "../../../components/ProgressBar";
import "./mergePdf.scss";
import CustomizedSnackbars from "../../../components/snackbars/CustomizedSnackbars";
import AdministratorHeader from "../../../components/header/AdministratorHeader";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";


export default function ListDirectory() {
  const Dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector((state) => state?.admin?.batchTypes);

  let folderData = useSelector((state) => state?.admin?.subFolder);
  const [subFolder, setSubFolder] = React.useState(null);

  useEffect(() => {
    setSubFolder(folderData?.data);
  }, [folderData]);
  const [value, setValue] = React.useState(null);
  const [folderName, setFolderName] = React.useState("");
  const [folderNameFrom, setFolderNameFormList] = React.useState("");
  const [disableAdd, setDisableAdd] = React.useState();
  const [open, setOpen] = React.useState(null);
  const [openNested, setNestedOpen] = React.useState(null);
  const apiStatus = useSelector((state) => state?.admin?.uploadData);

  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [expandedData, setExpandedData] = useState([]);
  const [id, setId] = useState("");

  const handleSubFolder = (data) => {
    Dispatch(acts.getProductTypeSubFolder(data?.id));
  };
  useEffect(() => {
    if (!expandedData[id]) {

      setExpandedData({
        ...expandedData,
        [id]: folderData?.data,
      });
      if (expandedNodes.includes(id)) {
        setExpandedNodes(expandedNodes.filter((nodeId) => nodeId !== id));
      } else {
        setExpandedNodes([...expandedNodes, id]);
      }
    }
  }, [folderData]);

  useEffect(() => {
    Dispatch(acts.getBatchRecordType());
    Dispatch(acts.getDrugTypeList());
  }, [Dispatch]);

  useEffect(() => {
    if (apiStatus && apiStatus != undefined) {
      if (apiStatus?.message != null && apiStatus?.next === false) {
        if (apiStatus?.message === "Invalid Token") {
          setErr(true);
          setMessage(apiStatus?.message);
        }
      }
    }
  }, [apiStatus]);

  const handleClick = (data) => {
    setValue(data?.id);
  };

  const handleContine = () => {
    let sendData = {
      value,
      folderName,
    };
    history.push("/merge-pdf-select", sendData);
  };


  const handleExpand = async (id) => {
    setId(id);
    await Dispatch(acts.getProductTypeSubFolder(id));
  }

  const isNodeExpanded = (id) => expandedNodes.includes(id);
  const memoizedRenderTree = useMemo(() => {
    const cache = {};

    const renderTreeNode = (items) => {
      if (!Array.isArray(items) || items.length === 0) {
        return null;
      }

      return items.map((item) => {
        if (!cache[item.id]) {
          cache[item.id] = (
            <TreeItem
              key={item.id}
              nodeId={item.id}
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Radio id={item.id}
                    onClick={() => {
                      handleClick(item);
                    }} style={{ marginRight: "10px" }} />

                  <FolderIcon className="folder-icon" />
                  {/* first level folder............ */}
                  <p>{item.name}</p>


                  <div style={{ marginLeft: "auto" }}>
                    <Button onClick={() => handleExpand(item.id)}>
                      {isNodeExpanded(item.id) ? (
                        <ExpandMoreIcon />
                      ) : (
                        <ChevronRightIcon />
                      )}
                    </Button>
                  </div>
                </div>
              }
            >
              {renderTreeNode(expandedData[item.id])}
            </TreeItem>
          );
        }
        return cache[item.id];
      });
    };
    return renderTreeNode(data?.data);
  }, [data, expandedData, isNodeExpanded, handleExpand]);
  return (
    <div>
      <Header />
      <Box className="list-directory">
        <Grid container>
          <Grid item md={3} sm={4}>
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid className="header-select" item md={9} sm={8}>
            <AdministratorHeader
              position="right"
              text="Merge Pdf"
              // isShow={true}
              to="/review-batch-records-details"
            />
            <Box className="Add-batch-records">
              <Buttons
                text="Continue"
                disabled={!value}
                onClick={handleContine}
                className="btn-continue"
              />
            </Box>
            <Grid container className="list_directory-container">
              {/* <Box > */}
              <TreeView
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                multiSelect
              >
                {memoizedRenderTree}
              </TreeView>
              {folderData?.loader === true ? <ProgressBar /> : ""}
              {/* </Box> */}
            </Grid>
            {err && (
              <CustomizedSnackbars
                severity="error"
                state={err}
                text={message}
                handleClose={() => setErr(false)}
              />
            )}
            {/* <Box
               className="list-directory-FBuuton"
              >
                <Buttons
                  text="Continue"
                  disabled={!value || !disableAdd}
                  onClick={handleContine}
                  size="large"
                />
              </Box> */}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
